function formatPremium(premium, start = "$") {
  if (!premium) return `${start}0`;
  return start + premium.toLocaleString("en", { useGrouping: true });
}

export default formatPremium;
